/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface TaskFilterDTO { 
    status?: Array<TaskFilterDTO.StatusEnum>;
    types?: Array<TaskFilterDTO.TypesEnum>;
    etlIds?: Array<string>;
    dateStart?: Date;
    dateEnd?: Date;
}
export namespace TaskFilterDTO {
    export type StatusEnum = 'IN_PROGRESS' | 'END' | 'WAIT' | 'ERROR' | 'INTERRUPTED';
    export const StatusEnum = {
        INPROGRESS: 'IN_PROGRESS' as StatusEnum,
        END: 'END' as StatusEnum,
        WAIT: 'WAIT' as StatusEnum,
        ERROR: 'ERROR' as StatusEnum,
        INTERRUPTED: 'INTERRUPTED' as StatusEnum
    };
    export type TypesEnum = 'IMPORT_DATA' | 'EXPORT_DATA';
    export const TypesEnum = {
        IMPORTDATA: 'IMPORT_DATA' as TypesEnum,
        EXPORTDATA: 'EXPORT_DATA' as TypesEnum
    };
}